import axios from 'axios';
import authService from './authService';

const API_URL = '/admin/';

// Add a request interceptor to include the auth token
axios.interceptors.request.use(
  (config) => {
    const user = authService.getCurrentUser();
    if (user && user.accessToken) {
      config.headers.Authorization = 'Bearer ' + user.accessToken;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

class AdminService {
  getAllUsers(page = 0, size = 10, sortBy = 'id', sortDir = 'asc') {
    return axios.get(API_URL + `users?page=${page}&size=${size}&sortBy=${sortBy}&sortDir=${sortDir}`);
  }

  getUserById(id) {
    return axios.get(API_URL + `users/${id}`);
  }

  createUser(userData) {
    return axios.post(API_URL + 'users', userData);
  }

  updateUser(id, userData) {
    return axios.put(API_URL + `users/${id}`, userData);
  }

  deleteUser(id) {
    return axios.delete(API_URL + `users/${id}`);
  }

  toggleUserStatus(id) {
    return axios.put(API_URL + `users/${id}/toggle-status`);
  }

  getAdminStats() {
    return axios.get(API_URL + 'stats');
  }

  getDuplicateUsers() {
    return axios.get(API_URL + 'users/duplicates');
  }

  getUsersByName(firstName, lastName) {
    return axios.get(API_URL + `users/duplicates/${firstName}/${lastName}`);
  }

  // OAuth User Management
  getOAuthUsers() {
    return axios.get(API_URL + 'users/oauth');
  }

  getUsersByOAuthProvider(provider) {
    return axios.get(API_URL + `users/oauth/${provider}`);
  }

  getDetailedUserStats() {
    return axios.get(API_URL + 'users/stats/detailed');
  }

  initializeUserQuotas() {
    return axios.post(API_URL + 'users/quotas/initialize');
  }

  updateUserQuota(userId, quota) {
    return axios.put(API_URL + `users/${userId}/quota?quota=${quota}`);
  }

  getUserQuotaInfo(userId) {
    return axios.get(API_URL + `users/${userId}/quota-info`);
  }
}

export default new AdminService();